import { createReducer } from '@reduxjs/toolkit';
import { SET_DASHBOARD_STATS } from '../actions/dashboard';

type MoneyPointCount = {
  money_amount: number;
  point_amount: number;
  raw_point_amount: number;
  campaign_point_amount: number;
  count: number;
};

export type DashboardState = {
  topup: MoneyPointCount;
  payment: MoneyPointCount;
  balance: {
    saved_at: string;
    total_amount: MoneyPointCount;
    expire_this_month_amount: MoneyPointCount;
    expire_next_month_amount: MoneyPointCount;
    expire_after_next_month_amount: MoneyPointCount;
  };
};

const defaultState: DashboardState = {
  topup: {
    money_amount: 0,
    point_amount: 0,
    raw_point_amount: 0,
    campaign_point_amount: 0,
    count: 0,
  },
  payment: {
    money_amount: 0,
    point_amount: 0,
    raw_point_amount: 0,
    campaign_point_amount: 0,
    count: 0,
  },
  balance: {
    saved_at: '',
    total_amount: {
      money_amount: 0,
      point_amount: 0,
      raw_point_amount: 0,
      campaign_point_amount: 0,
      count: 0,
    },
    expire_this_month_amount: {
      money_amount: 0,
      point_amount: 0,
      raw_point_amount: 0,
      campaign_point_amount: 0,
      count: 0,
    },
    expire_next_month_amount: {
      money_amount: 0,
      point_amount: 0,
      raw_point_amount: 0,
      campaign_point_amount: 0,
      count: 0,
    },
    expire_after_next_month_amount: {
      money_amount: 0,
      point_amount: 0,
      raw_point_amount: 0,
      campaign_point_amount: 0,
      count: 0,
    },
  },
};

const dashboardReducer = createReducer(defaultState, (builder) =>
  builder.addCase(SET_DASHBOARD_STATS, (_, action) => {
    return { ...action.payload };
  })
);

export default dashboardReducer;
